import { useAsyncData, useRuntimeConfig } from '#imports'
import { type Ref, ref } from 'vue'

import type { ReviewsAISummary } from '@backmarket/nuxt-layer-reviews/api/reviews/types'
import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'
import { getAsyncDataKey } from '@backmarket/nuxt-module-http-v2/getAsyncDataKey'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

import { useUrlParams } from '~/scopes/product/composables/useUrlParams'

import { useRequests } from '../../reviews-display/composables/useRequests'

export const AI_SUMMARY_EXPERIMENT_NAME = 'experiment.reviewsAiSummary'
export const AI_SUMMARY_EXPERIMENT_ENABLED_VARIANT = 'withAIReview'
function useReviewsAIExperimentIsEnabled() {
  const experiments = useExperiments()

  return (
    experiments[AI_SUMMARY_EXPERIMENT_NAME] ===
    AI_SUMMARY_EXPERIMENT_ENABLED_VARIANT
  )
}
export function useReviewsAISummary(): {
  data: Ref<ReviewsAISummary | null>
  pending: Ref<boolean>
} {
  const requests = useRequests()
  const { productId } = useUrlParams()

  const $httpFetch = useHttpFetch()

  const isExperimentEnabled = useReviewsAIExperimentIsEnabled()

  const { FF_REVIEWS_ENABLE_AI_SUMMARY_SSR } = useRuntimeConfig().public

  const hasReviewsAISummary =
    requests &&
    'hasAIReviewsSummary' in requests &&
    requests.hasAIReviewsSummary &&
    isExperimentEnabled

  if (!hasReviewsAISummary)
    return {
      data: ref<ReviewsAISummary | null>(null),
      pending: ref(false),
    }

  const { data, pending } = useAsyncData(
    getAsyncDataKey('reviews-ai-summary', { productId }),
    async () => {
      return $httpFetch('/reviews/v1/products/:uuid/reviews-ai-summary', {
        pathParams: { uuid: productId },
      })
    },
    {
      lazy: true,
      server: FF_REVIEWS_ENABLE_AI_SUMMARY_SSR,
    },
  )

  return {
    data,
    pending,
  }
}
